import { css } from "styled-components"

export const enum Color {
  PRIMARY_TEXT = '#2C2C2C',
  PRIMARY_TEXT_WITH_OPACITY = '#2C2C2C99',
  ACCENT = '#546EF1',
  PRIMARY_GREY = '#959595',
  BG_MAIN = '#F0F0F4',
  WHITE = '#FFFFFF',
  GREY_40 = '#F0F0F0',
  ERROR = '#F15454',
  STROKE = '#E1E1EA'
}

export const enum MediaBreakpoint {
  MIN_PHONE = 430,
  DESKTOP = 1024,
}

export const baseMediaStyles = css`
  padding: 0 16px;
  width: 100%;
  
  @media (min-width: ${MediaBreakpoint.MIN_PHONE}px) {
    width: 390px;
    padding: 0;
  }
`

export const baseMediaStylesVariant2 = css`
  width: 328px;

  @media (min-width: ${MediaBreakpoint.MIN_PHONE}px) {
    width: 390px;

  }
`

export const basePageStyles = css`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`

export const baseColumnStyles = css`
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  ${baseMediaStyles};
`

export const titleLargeStyles = css`
  font-weight: 800;
  font-size: 24px;
  line-height: 1.4;
  color: ${Color.PRIMARY_TEXT};
  text-align: center;

  @media (min-width: ${MediaBreakpoint.MIN_PHONE}px) {
    font-size: 28px;

  }
`

export const accentStrongStyles = css`
  ${titleLargeStyles};
  color: ${Color.ACCENT};
  font-feature-settings: 'liga' off, 'clig' off;
`

export const bodyMediumStyles = css`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: ${Color.PRIMARY_TEXT};
  text-align: center;
`

export const textMediumStyles = css`
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: ${Color.PRIMARY_TEXT};
  text-align: center;
`

export const fullViewHeight = css`
  min-height: var(--full-height, 100vh);

  @supports (min-height: 100dvh) {
    min-height: 100dvh;
  }
`